/**
 * Storefront home page — wires the featured-products "Add to Cart" buttons
 * and mounts the header cart badge.
 */
import { addToCart, mountCartBadge } from "../Cart/StorefrontCart";
import { markSavedWishlistButtons, mountWishlistBadge, toggleWishlist } from "../Wishlist/WishlistClient";
import { showToast } from "../Toast/StorefrontToast";
import { mountRecentlyViewed } from "../RecentlyViewed/RecentlyViewed";

function init(): void {
    mountCartBadge();
    mountWishlistBadge();
    markSavedWishlistButtons(); // red heart on featured parts already in the wishlist

    const recentHost = document.querySelector<HTMLElement>('[data-recently-viewed]');
    if (recentHost) mountRecentlyViewed(recentHost);

    for (const btn of Array.from(document.querySelectorAll<HTMLElement>('.sf-featured-add'))) {
        btn.addEventListener('click', async (e) => {
            e.preventDefault();
            const id = parseInt(btn.getAttribute('data-id') || '0', 10);
            if (!id) return;
            try {
                await addToCart(id, 1);
            } catch (err) {
                showToast((err as Error).message, 'error');
                return;
            }
            const original = btn.textContent;
            btn.textContent = '✓ Added';
            btn.classList.add('is-added');
            window.setTimeout(() => { btn.textContent = original; btn.classList.remove('is-added'); }, 1200);
        });
    }

    for (const btn of Array.from(document.querySelectorAll<HTMLButtonElement>('[data-action="add-to-wishlist"]'))) {
        btn.addEventListener('click', async (e) => {
            e.preventDefault();
            const id = parseInt(btn.getAttribute('data-id') || '0', 10);
            await toggleWishlist(btn, id, 1); // red heart = saved; clicking it again removes
        });
    }
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
} else {
    init();
}
